import React from 'react';
import CoursePageTemplate from './components/CoursePageTemplate';

function CaroKann() {
  return (
    <CoursePageTemplate
      courseId="enfrentar-caro-kann"
      backgroundColor="linear-gradient(135deg, #38B6FF 0%, #1a8fd6 100%)"
    />
  );
}

export default CaroKann;
